import React from 'react';
import PropTypes from 'prop-types';
import { useNeuroMessages } from '../../components';
import { IdleTimer, Modal } from '../../../neuro-ui';

const IdleModal = ({ timeout, onIdle, onClick, timerProps, ...props }) => {
  const [time, setRemainingTime] = React.useState(
    Math.round(timeout / 1000, 1)
  );
  const idleTimer2 = React.useRef(null);
  const messageContext = useNeuroMessages();

  const getTimeoutMessage = (value, opts = {}) => {
    const timeoutMessage = messageContext.formatIntlMessage(
      { id: `${value}` },
      opts
    );

    return (
      timeoutMessage ||
      messageContext.formatIntlMessage({ id: `default.${value}` }, opts)
    );
  };

  React.useEffect(() => {
    const id = setInterval(
      () =>
        setRemainingTime(
          idleTimer2 &&
            idleTimer2.current &&
            Math.round(idleTimer2.current.getRemainingTime() / 1000, 1)
        ),
      1000
    );
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <IdleTimer
        ref={idleTimer2}
        timeout={timeout}
        onIdle={() => onIdle && onIdle()}
        ignoreEvents
        {...timerProps}
      />
      <Modal
        show
        title={getTimeoutMessage('timeout.title')}
        nodeId="root"
        onClose={() => onClick && onClick()}
        {...props}
      >
        <p>{getTimeoutMessage('timeout.message', { time })}</p>
        <button
          className="btn btn-primary"
          type="button"
          data-dismiss="modal"
          onClick={() => {
            onClick && onClick();
          }}
          role="button"
          aria-label={getTimeoutMessage('timeout.action')}
        >
          {getTimeoutMessage('timeout.action')}
        </button>
      </Modal>
    </>
  );
};

IdleModal.propTypes = {
  timerProps: PropTypes.shape({}),
  timeout: PropTypes.number,
  onClick: PropTypes.func,
  onIdle: PropTypes.func,
};
IdleModal.defaultProps = {
  timerProps: {},
  timeout: 12000,
  onClick: null,
  onIdle: null,
};
export default IdleModal;
